import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomTextField,
  CustomCheckbox,
} from '../../../common';

const DebtEditTable = ({
  coupons,
  modifiedCoupons,
  payChecks,
  regularizeChecks,
  onModifiedCouponsChange,
  onPayChecksChange,
  onRegularizeChecksChange,
}) => {
  const handleThirdDueAmountChange = (index, newValue) => {
    const newModifiedCoupons = [...modifiedCoupons];
    
    if (!newModifiedCoupons[index]) {
      newModifiedCoupons[index] = { ...coupons[index] };
    }

    newModifiedCoupons[index].third_due_amount = parseFloat(newValue) || 0;
    onModifiedCouponsChange(newModifiedCoupons);
  };

  const handleThirdDueDateChange = (index, newDate) => {
    const newModifiedCoupons = [...modifiedCoupons];

    if (!newModifiedCoupons[index]) {
      newModifiedCoupons[index] = { ...coupons[index] };
    }

    newModifiedCoupons[index].third_due_date = newDate;
    onModifiedCouponsChange(newModifiedCoupons);
  };

  const handlePayCheckChange = (index) => {
    const updatedPayChecks = [...payChecks];
    updatedPayChecks[index] = !updatedPayChecks[index];
    onPayChecksChange(updatedPayChecks);

    if (updatedPayChecks[index]) {
      const updatedRegularizeChecks = [...regularizeChecks];
      updatedRegularizeChecks[index] = false;
      onRegularizeChecksChange(updatedRegularizeChecks);
    }
  };

  const handleRegularizeCheckChange = (index) => {
    const updatedRegularizeChecks = [...regularizeChecks];
    updatedRegularizeChecks[index] = !updatedRegularizeChecks[index];
    onRegularizeChecksChange(updatedRegularizeChecks);

    if (updatedRegularizeChecks[index]) {
      const updatedPayChecks = [...payChecks];
      updatedPayChecks[index] = false;
      onPayChecksChange(updatedPayChecks);
    }
  };

  return (
    <GeneralTableBox sx={{ 
      maxHeight: '400px',
      overflow: 'auto',
    }}>
      <Table aria-label="debt edit table" stickyHeader>
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%" wxs="15%">
              Cuota
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="12%">
              $ 1er Venc.
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="12%">
              Fecha 1er
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="12%">
              $ 3er Venc.
            </HeadTableCell>
            <HeadTableCell wmd="8%" wxs="8%">
              Pagar
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="12%">
              Fecha 3er
            </HeadTableCell>
            <HeadTableCell wmd="12%" wxs="12%">
              $ Interés
            </HeadTableCell>
            <HeadTableCell wmd="8%" wxs="8%">
              Regularizar
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {coupons.map((coupon, index) => (
            <TableRow key={index}>
              <RowTableCell fontxs="12px" fontmd="14px">
                Cuota: {coupon.fee_number1}
                {coupon.fee_number2 ? ` - ${coupon.fee_number2}` : ''}
              </RowTableCell>
              
              <RowTableCell>
                <CustomTextField
                  size="small"
                  value={coupon.first_due_amount}
                  disabled
                  sx={{ 
                    mt: 0,
                    width: '100%',
                    '& input': { textAlign: 'center', fontSize: '12px' },
                    '& .MuiOutlinedInput-root': { height: '32px' },
                  }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomTextField
                  type="date"
                  size="small"
                  value={coupon.first_due_date.split('T')[0]}
                  disabled
                  sx={{ 
                    mt: 0,
                    width: '100%',
                    '& .MuiOutlinedInput-root': { height: '32px' },
                  }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomTextField
                  size="small"
                  value={
                    typeof modifiedCoupons[index]?.third_due_amount === 'number'
                      ? modifiedCoupons[index].third_due_amount.toFixed(2)
                      : coupon.third_due_amount?.toFixed(2) || '0.00'
                  }
                  onChange={(e) => handleThirdDueAmountChange(index, e.target.value)}
                  sx={{ 
                    mt: 0,
                    width: '100%',
                    '& input': { textAlign: 'center', fontSize: '12px' },
                    '& .MuiOutlinedInput-root': { height: '32px' },
                  }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomCheckbox
                  checked={!!payChecks[index]}
                  onChange={() => handlePayCheckChange(index)}
                  sx={{ padding: '4px' }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomTextField
                  type="date"
                  size="small"
                  value={
                    modifiedCoupons[index]?.third_due_date || 
                    coupon.third_due_date.split(' ')[0]
                  }
                  onChange={(e) => handleThirdDueDateChange(index, e.target.value)}
                  sx={{ 
                    mt: 0,
                    width: '100%',
                    '& .MuiOutlinedInput-root': { height: '32px' },
                  }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomTextField
                  size="small"
                  value={
                    modifiedCoupons[index]?.interest?.toFixed(2) ||
                    (coupon.third_due_amount - coupon.first_due_amount)?.toFixed(2) ||
                    '0.00'
                  }
                  disabled
                  sx={{ 
                    mt: 0,
                    width: '100%',
                    '& input': { textAlign: 'center', fontSize: '12px' },
                    '& .MuiOutlinedInput-root': { height: '32px' },
                  }}
                />
              </RowTableCell>
              
              <RowTableCell>
                <CustomCheckbox
                  checked={!!regularizeChecks[index]}
                  onChange={() => handleRegularizeCheckChange(index)}
                  sx={{ padding: '4px' }}
                />
              </RowTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default DebtEditTable;